export enum OneTrustGroup {
    Performance = "C0002",
    Functional = "C0003",
    Targeting = "C0004",
    Social = "C0005",
}
